import type { enAirport } from './en.airport';

export const zhTWAirport: typeof enAirport = {
  airport: {
    mapNames: { airport: '桃園機場' },
    zones: { ap_arrivals: '入境大廳', ap_terminal: '第二航廈', ap_gates: '登機門' },
    objects: {
      ap_mrt: '機場捷運（往臺北）',
      ap_mrtTaipei: '機場捷運（往機場）',
      ap_checkin: '報到櫃檯',
      ap_info: '服務台',
      ap_security: '安全檢查',
      ap_gate: 'C7 登機門 · 巴塞隆納',
      ap_duty: '免稅商店',
      ap_belt: '行李轉盤',
      wc_public: '公共廁所',
      rent_shop: '租車店',
      bank_counter: '燈籠銀行',
      bank_atm: '提款機',
    },
    npc: {},
    items: {},
    texts: {
      mrtToAirport: '紫色的機場捷運從臺北車站到桃園機場，大約 40 分鐘。',
      mrtGo: '🚇 搭去機場',
      mrtBack: '🚇 搭回臺北',
      mrtBackText: '機場捷運帶你回到臺北車站。',
      checkin: '早安！今天要飛去哪裡？請準備好護照。',
      checkinAsk: '用英文要怎麼買票？',
      ask: ['One ticket to Barcelona, please.', 'Barcelona give ticket me.', 'I want go Barcelona now.'],
      wrong: '嗯，再試一次——想想「one ticket to… please」。',
      ticket: (price: number) => `✈️ 巴塞隆納 — ${price} 枚硬幣（來回）`,
      bought: '這是你的登機證：C7 登機門，23A 靠窗座位。先過安檢，再跟著指標走。一路順風！',
      poor: (price: number) => `到巴塞隆納的來回機票要 ${price} 枚硬幣。去銀行存錢再回來吧！`,
      haveTicket: '你已經有登機證了。過安檢，去 C7 登機門！',
      tooLate: (h: string) => `飛巴塞隆納的最後一班 ${h} 起飛，今天已經走了。明天早上再來吧。`,
      flown: '你今天已經飛過了。一天一趟大旅行就夠了！',
      securityText: '安全檢查。把背包放到輸送帶上。哪一樣東西「不能」放在隨身行李裡？',
      securityQ: ['一大瓶水', '一本書', '一個三明治'],
      securityOk: '答對了！超過 100 毫升的液體不能帶。喝掉或丟掉，然後過來吧。',
      securityWrong: '不是那個。想想：什麼是液體，而且比一杯還多？',
      securityDone: '你已經通過安檢。C7 登機門在右邊。',
      securityNoTicket: '請出示登機證！先到報到櫃檯買票。',
      gateText: 'C7 登機門。飛往巴塞隆納的 BR 67 班機正在登機。大約要飛 14 小時——帶本書吧！',
      board: '✈️ 登機',
      needSecurity: '登機前必須先通過安檢。',
      needTicket: '沒有登機證？報到櫃檯在左邊。',
      homeGate: '歡迎回到臺灣！到 4 號轉盤領行李，再搭機場捷運去臺北。',
      info: '桃園機場 1979 年啟用，是臺灣最大的機場。兩座航廈，飛往一百多個城市——第三航廈還在興建中。',
      infoQ: '臺灣最大的機場是哪一個？',
      infoA: ['桃園', '松山', '高雄'],
      infoOk: '對！大部分的國際航班都從桃園起飛。',
      infoWrong: '不太對——就是你現在站的這一個！',
      duty: '免稅商店：鳳梨酥、茶葉和迷你臺北 101。要買個禮物帶回家嗎？',
      dutyBuy: '🍍 鳳梨酥（40 枚硬幣）',
      belt: '行李箱轉啊轉。你的是貼著小兔子貼紙的那一個。',
      flyTo: ['飛機從桃園翠綠的平原起飛……', '腳下是雲，頭上是太陽……你睡了又醒，醒了又睡……', '山！然後是蔚藍的地中海……巴塞隆納到了。'],
      flyHome: ['飛機爬升到地中海上空……', '晚餐、一部電影、睡了一大覺……', '腳下是綠色的山：臺灣！歡迎回家。'],
      announce: (place: string) => `“Ladies and gentlemen, welcome to ${place}.”`,
      arrive: (place: string) => `歡迎來到${place}！`,
    },
    hsr: {
      kaohsiung: '高雄（高鐵）',
      tainan: '台南（高鐵）',
      hintKaohsiung: '南部的大港都',
      hintTainan: '最古老的城市，廟宇和小吃',
      toSouth: ['高鐵以 300 公里的時速滑出車站……', '稻田和魚塭從窗外飛過……', '前方出現高樓——臺灣的南部到了！'],
    },
    wc: { text: '乾淨的公共廁所。記得洗手！', use: '🚻 上廁所', wash: '🧼 只洗手' },
    rent: {
      text: '租一台車騎一整天！比走路快——安全帽免費。',
      bike: '🚲 腳踏車',
      kick: '🛴 滑板車',
      ebike: '🛵 電動機車（附安全帽）',
      price: (n: number) => `${n} 枚硬幣`,
      rented: (what: string) => `你租了${what}。可以在任何租車店歸還，或者走進室內就會自動還車。`,
      names: { bike: '一台腳踏車', kick: '一台滑板車', ebike: '一台電動機車' },
      ret: '↩️ 還車',
      returned: '謝謝！車已歸還。',
      poor: '硬幣不夠租這一台。',
      indoor: '你把車停在門口——室內不能騎！',
      helmet: '戴好安全帽！在臺灣騎機車人人都戴。',
      rule: '靠近人的時候放慢速度，機車絕對不能騎上人行道。',
    },
    bank: {
      title: '🏦 燈籠銀行',
      hello: (balance: number, coins: number) => `歡迎光臨燈籠銀行！你的帳戶有 **${balance}🪙**。口袋裡：**${coins}🪙**。`,
      atm: (balance: number, coins: number) => `提款機。帳戶：**${balance}🪙** · 口袋：**${coins}🪙**。`,
      deposit: (n: number) => `⬆️ 存入 ${n}🪙`,
      depositAll: (n: number) => `⬆️ 全部存入（${n}🪙）`,
      withdraw: (n: number) => `⬇️ 提領 ${n}🪙`,
      withdrawAll: (n: number) => `⬇️ 全部提領（${n}🪙）`,
      statement: '📄 交易明細',
      goal: '🎯 儲蓄目標',
      why: '❓ 為什麼要把錢存在銀行？',
      whyText: '放在銀行的錢很安全，而且每天早上銀行會付你 **2% 的利息**——謝謝你把錢放在這裡。存得越多，長得越多！',
      done: (balance: number) => `完成。你的帳戶現在有 **${balance}🪙**。`,
      interest: (n: number, balance: number) => `🏦 銀行付了 ${n}🪙 利息。餘額：${balance}🪙。`,
      empty: '你的帳戶是空的。存幾枚硬幣進來，開始賺利息吧！',
      stmtTitle: '最近的交易',
      stmtNone: '還沒有交易。',
      kinds: { in: '存款', out: '提款', interest: '利息', goal: '達成目標' },
      goalText: (goal: number, balance: number) => (goal ? `你的目標：**${goal}🪙**。你有 ${balance}🪙，還差 ${Math.max(0, goal - balance)}。` : '還沒有目標。選一個吧：達成就能得到星星！'),
      goalSet: (n: number) => `🎯 存到 ${n}🪙`,
      goalClear: '取消目標',
      goalReached: (n: number) => `🎉 達成目標：存到 ${n}🪙 了！+5⭐`,
      reward: '想存錢去搭飛機？巴塞隆納要 300 枚硬幣。',
      poor: '你口袋裡沒有那麼多。',
      poorBank: '帳戶裡沒有那麼多。',
      payCard: (price: number, pocket: number, missing: number, bank: number) => `要 ${price}🪙，你口袋裡有 ${pocket}🪙。差的 ${missing}🪙 用銀行卡付嗎？（帳戶：${bank}🪙）`,
      payCardBtn: (n: number) => `💳 從帳戶付 ${n}🪙`,
      cannotPay: (price: number, pocket: number, bank: number) => `要 ${price}🪙。你口袋裡有 ${pocket}🪙、銀行有 ${bank}🪙：還差 ${price - pocket - bank}🪙。`,
      wallet: '👛 錢包',
      potName: '銀行',
    },
    mapUi: {
      here: '📍 這裡',
      taiwan: '🗺️ 臺灣',
      goHere: '🧭 帶我去',
      guiding: (what: string) => `🧭 正在帶你去：${what}`,
      pinCleared: '你到了。',
      kinds: { transport: '交通', rental: '租車', toilet: '廁所', bank: '銀行', food: '美食', shop: '商店', sight: '景點', hotel: '旅館', info: '資訊', door: '出入口' },
      door: (to: string) => `往${to}的門`,
      how: {
        town: '家。一切從這裡開始：車站在大街的東邊。',
        taipei: '從車站搭火車（60 枚硬幣）。捷運可到西門町、龍山寺、自由廣場和北投。',
        hualien: '從車站搭火車（90 枚硬幣）。台灣好行可到太魯閣和七星潭。',
        kaohsiung: '從車站搭高鐵（150 枚硬幣）。',
        tainan: '從車站搭高鐵（130 枚硬幣）。',
        airport: '從臺北車站搭機場捷運。',
        barcelona: '從桃園機場搭飛機（300 枚硬幣，來回）。報到、安檢、C7 登機門。',
      },
      youAreHere: '你在這裡',
      abroad: '國外',
    },
  },
};
